/* tslint:disable */
/* eslint-disable */
/**
 * Tenants API
 * API for managing tenants
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoredFileIdRequest
 */
export interface StoredFileIdRequest {
    /**
     * 
     * @type {string}
     * @memberof StoredFileIdRequest
     */
    storedFileId: string;
}

/**
 * Check if a given object implements the StoredFileIdRequest interface.
 */
export function instanceOfStoredFileIdRequest(value: object): value is StoredFileIdRequest {
    if (!('storedFileId' in value) || value['storedFileId'] === undefined) return false;
    return true;
}

export function StoredFileIdRequestFromJSON(json: any): StoredFileIdRequest {
    return StoredFileIdRequestFromJSONTyped(json, false);
}

export function StoredFileIdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoredFileIdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'storedFileId': json['storedFileId'],
    };
}

export function StoredFileIdRequestToJSON(json: any): StoredFileIdRequest {
    return StoredFileIdRequestToJSONTyped(json, false);
}

export function StoredFileIdRequestToJSONTyped(value?: StoredFileIdRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'storedFileId': value['storedFileId'],
    };
}

